import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withRouter } from "next/router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Head from "components/Head";
import Nav from "components/Nav";
import AppNote from "components/AppNote";
import { UNAUTHED_ROUTES, AUTHED_REDIRECT_ROUTES } from "utils/paths";
import { COLORS } from "utils/styles";
import { fetchAppConfiguration } from "actions/app";
import { fetchUserDetails, logout } from "actions/auth";
import { getPageMetaProps } from "utils/constants/meta";
import dynamic from "next/dynamic";
import { hideNavBar, isManifestPath } from "utils/route";
import ErrorBoundary from "components/ErrorBoundary";
import { getJWT } from "utils/auth";

const NoComponent = () => <span />;
const CookieConsent = dynamic(() => import("components/CookieConsent"), {
  ssr: false,
  loading: NoComponent
});

const DEFAULT_CLASSSES = {
  container: "layout relative h-100"
};

class Layout extends Component {
  constructor(props) {
    super(props);
    this.getUserAnalyticsDetails = this.getUserAnalyticsDetails.bind(this);
    this.classes = { ...DEFAULT_CLASSSES, ...props.customClasses };
  }

  componentDidMount() {
    this.refreshUser();
  }

  refreshUser() {
    const { user, actions } = this.props;
    const userID = user.get("id");
    const canRefetch = getJWT() && !userID;
    if (canRefetch) {
      actions.fetchUserDetails(true);
    }
  }

  /**
   * Entry point from external APIs (e.g Stripe)
   * Where we want to do some local component handshake logic without being redirected through onboarding even if eligible
   */
  authedRedirectRoute(pathname) {
    return AUTHED_REDIRECT_ROUTES.indexOf(pathname) >= 0;
  }

  unauthedRoute(pathname) {
    return UNAUTHED_ROUTES.indexOf(pathname) >= 0;
  }

  getUserAnalyticsDetails() {
    const { user, username } = this.props;
    const details = {
      id: user.get("id"),
      uuid: user.get("uuid"),
      email: user.get("email"),
      created_at: user.get("created_at")
    };
    console.log("------- ~ user details", details);
    if (username) {
      details.username = username;
    }

    return details;
  }

  render() {
    const { children, customClasses, router, metadata } = this.props;

    if (!children) {
      throw new Error("Layout requires child components");
    }
    console.log("User details", this.getUserAnalyticsDetails());
    const classes = { ...DEFAULT_CLASSSES, customClasses };

    const showNav = !hideNavBar(router.pathname);

    const isGreyBg = isManifestPath(router.pathname);

    return (
      <ErrorBoundary>
        <div className={classes.container}>
          <Head {...getPageMetaProps({ path: router.pathname, metadata })} />
          {/* {showNav && (
            <Fragment>
              <Nav />
              <div style={{ height: 52 }} className="dib h-100" />
            </Fragment>
          )} */}
          {children && children()}
          <AppNote />
          <CookieConsent />
          <style jsx global>
            {`
          :global(html),
          :global(body) {
            background-color: ${isGreyBg ? COLORS.bg : COLORS.white};
          `}
          </style>
        </div>
      </ErrorBoundary>
    );
  }
}

Layout.propTypes = {
  router: PropTypes.object.isRequired,
  device: PropTypes.object,
  render: PropTypes.func.isRequired,
  customClasses: PropTypes.object,
  user: PropTypes.object,
  actions: PropTypes.object,
  appCapabilities: PropTypes.object,
  onboardingsRemain: PropTypes.bool,
  hasAppOnboardingConfig: PropTypes.bool,
  authLoading: PropTypes.bool,
  username: PropTypes.string
};

Layout.defaultProps = {
  render: () => {},
  device: {}
};

const mapStateToProps = (state) => {
  const baseProps = {
    user: state.getIn(["user", "data"]),
    authLoading: Boolean(state.getIn(["auth", "isLoading"]))
  };

  return baseProps;
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchUserDetails,
      fetchAppConfiguration,
      logout
    },
    dispatch
  )
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
